import React from 'react';
export function Logo({
  className = 'w-16 h-16'
}: {
  className?: string;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/rF16au1gSSK74LUhnPVkzT/file_00000000c61471f7b5cfb81b4b40a7dc.png" alt="Structured Nutrition" className={className} data-id="element-104" />;
}